<template lang="pug">
	.offer-preview-mini(v-if="showed" v-pseudo-modal="'offer-preview'" :style="{top: top + 'px', right: right + 'px'}")
		.img-offer-preview#tttt(v-if="offer && offer.images")
			img(:src="imageUrl")

</template>

<script>

	import Screen 			from './../../mixins/screen';
	import { Asset } 		from './../../services/Asset';

	export default {
		name: "OfferPreviewMini",
		mixins: [Screen],
		screen: {
			events: {
				"Show Offer Preview": function(offer, e, el) {

					this.offer = offer;
					this.imageUrl = JSON.parse(offer.images)[0];

					this.update();

					let rect = el.getBoundingClientRect();

					this.top = rect.top;
					this.right = document.body.clientWidth - rect.left;


					Broadcast.call("Pseudo Modal Show", ["offer-preview"]);

				},
				"Hide Offer Preview": function() {

					this.offer = null;

					this.update();

					Broadcast.call("Pseudo Modal Hide", ["offer-preview"]);

				}
			}
		},
		data() {

			this.offer = null;
			//this.assetURL = '';

			return {
				showed: true,
				top: 0,
				right: 0
			};

		},
		computed: {
		},
		methods: {
			collectData() {

			}
		}
	}
</script>

<style lang="sass">

	.offer-preview-mini
		position: absolute
		z-index: 10000
		top: 0
		right: 0
		//max-width: 500px
		border-radius: 0.25rem
		padding: 0.25rem
		border: 1px solid #23282c
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
		background-color: #3a4149

		>.img-offer-preview

			img
				max-width: 100px
				max-height: 100px

</style>
